var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlightlySatisfied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 0-16 0 8 8 0 1 0 16 0m2 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10M8 7.5a1.5 1.5 0 1 1-3 0A1.5 1.5 0 0 1 6.5 6 1.54 1.54 0 0 1 8 7.5m7 0a1.5 1.5 0 1 1-3 0A1.5 1.5 0 0 1 13.5 6 1.54 1.54 0 0 1 15 7.5m-5 7.73a5.46 5.46 0 0 1-4.19-1.81L7.23 12c.666.839 1.701 1.299 2.77 1.23 1.069.069 2.104-.391 2.77-1.23l1.42 1.42A5.46 5.46 0 0 1 10 15.23z",
    fill: "#ceb15d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightlySatisfied);
export default __webpack_public_path__ + "static/media/slightly_satisfied.89e5cfa7.svg";
export { ForwardRef as ReactComponent };